module.exports = __webpack_public_path__ + "static/media/29FUNOV3.cce9e3e0.jpg";